import { toast } from "react-toastify";

/**
 * Handle form submission for the new comprehensive claim creation API
 * This function collects all form data and formats it according to the API specification
 * Note: DAAQ is now auto-generated by the gateway based on agency and management type
 */
export const handleSubmitClaimNew = async (dispatch, Actions, setIsSubmitting, setOpenAddDialog, onCreated) => {
  try {
    setIsSubmitting(true);

    // ===== CONTRACT SECTION =====
    const policyNumber = document.querySelector('input[name="policyNumber"]')?.value || "";
    const policyType = document.querySelector('select[name="policyType"]')?.value || "";
    const policyUsage = document.querySelector('select[name="policyUsage"]')?.value || "";
    
    // Policy Holder
    const policyHolderCode = document.querySelector('input[name="policyHolderCode"]')?.value || "";
    const policyHolderIdentityNumber = document.querySelector('input[name="policyHolderIdentityNumber"]')?.value || "";
    const policyHolderFirstName = document.querySelector('input[name="policyHolderFirstName"]')?.value || "";
    const policyHolderLastName = document.querySelector('input[name="policyHolderLastName"]')?.value || "";
    const policyHolderBirthDate = document.querySelector('input[name="policyHolderBirthDate"]')?.value || "";
    const policyHolderRole = document.querySelector('select[name="policyHolderRole"]')?.value || "InsuredDriver";
    
    // Policy Dates
    const policyEffectDate = document.querySelector('input[name="policyEffectDate"]')?.value || "";
    const policyExpirationDate = document.querySelector('input[name="policyExpirationDate"]')?.value || "";
    
    // Vehicle Information
    const vehicleRegistrationNumber = document.querySelector('input[name="vehicleRegistrationNumber"]')?.value || "";
    const vehicleBrand = document.querySelector('input[name="vehicleBrand"]')?.value || "";
    const vehicleModel = document.querySelector('input[name="vehicleModel"]')?.value || "";
    const vehicleFirstCirculationDate = document.querySelector('input[name="vehicleFirstCirculationDate"]')?.value || "";
    const vehiclePower = document.querySelector('input[name="vehiclePower"]')?.value || "";
    const vehicleSeatsNumber = document.querySelector('input[name="vehicleSeatsNumber"]')?.value || "";
    const vehicleEngineNumber = document.querySelector('input[name="vehicleEngineNumber"]')?.value || "";
    const vehicleChassisNumber = document.querySelector('input[name="vehicleChassisNumber"]')?.value || "";
    
    // Reference Entities
    const agencyLabel = document.querySelector('input[name="agencyLabel"]')?.value || "";

    // ===== CLAIM SECTION =====
    const claimNumber = document.querySelector('input[name="claimNumber"]')?.value || "";
    const claimAmount = document.querySelector('input[name="claimAmount"]')?.value || "0";
    const occurrenceDate = document.querySelector('input[name="occurrenceDate"]')?.value || "";
    const declarationDate = document.querySelector('input[name="declarationDate"]')?.value || "";
    const reportingAgency = document.querySelector('select[name="declarationAgency"]')?.value || "";
    const reportingType = document.querySelector('select[name="reportingType"]')?.value || "FirstPartyClaim";
    const damageType = document.querySelector('select[name="damageType"]')?.value || "MaterialDamage";
    const responsibility = document.querySelector('select[name="responsibility"]')?.value || "UnderInvestigation";
    const claimStatus = document.querySelector('select[name="claimStatus"]')?.value || "OPEN";
    const managementType = document.querySelector('select[name="managementType"]')?.value || "classique";
    const registrationNumber = document.querySelector('input[name="registrationNumber"]')?.value || "";
    const driver = document.querySelector('input[name="driver"]')?.value || "";
    const claimLocation = document.querySelector('input[name="claimLocation"]')?.value || "";
    const carLocation = document.querySelector('input[name="carLocation"]')?.value || "";
    const vehicleState = document.querySelector('input[name="vehicleState"]')?.value || "";
    const recourseAmount = document.querySelector('input[name="recourseAmount"]')?.value || "0";
    const typeOfClaim = document.querySelector('select[name="typeOfClaim"]')?.value || "";
    // flagFraud is now always false (handled in backend)
    const reportingNumber = document.querySelector('input[name="reportingNumber"]')?.value || "";
    
    // Get coverages as array from multi-select
    const coveragesSelect = document.querySelector('select[name="coverages"]');
    const selectedCoverages = coveragesSelect ? Array.from(coveragesSelect.selectedOptions).map(option => option.value) : [];

    // ===== THIRD PARTY SECTION =====
    const thirdPartyType = document.querySelector('select[name="thirdPartyType"]')?.value || "person";
    const thirdPartyRole = document.querySelector('select[name="thirdPartyRole"]')?.value || "AdverseDriver";
    const thirdPartyFirstName = document.querySelector('input[name="thirdPartyFirstName"]')?.value || "";
    const thirdPartyLastName = document.querySelector('input[name="thirdPartyLastName"]')?.value || "";
    const thirdPartyIdentityNumber = document.querySelector('input[name="thirdPartyIdentityNumber"]')?.value || "";
    const thirdPartyBirthDate = document.querySelector('input[name="thirdPartyBirthDate"]')?.value || "";
    const thirdPartyOrganizationName = document.querySelector('input[name="thirdPartyOrganizationName"]')?.value || "";
    const thirdPartyActivity = document.querySelector('input[name="thirdPartyActivity"]')?.value || "";
    const thirdPartyTaxId = document.querySelector('input[name="thirdPartyTaxId"]')?.value || "";
    
    // Third Party Policy & Vehicle (for Good creation)
    const thirdPartyPolicyNumber = document.querySelector('input[name="thirdPartyPolicyNumber"]')?.value || "";
    const thirdPartyPolicyType = document.querySelector('select[name="thirdPartyPolicyType"]')?.value || "INDIVIDUALPOLICY";
    const thirdPartySubscriptionDate = document.querySelector('input[name="thirdPartySubscriptionDate"]')?.value || "";
    const thirdPartyExpirationDate = document.querySelector('input[name="thirdPartyExpirationDate"]')?.value || "";
    // thirdPartyCancelationDate is now automatically set to expirationDate in backend
    const thirdPartyCode = document.querySelector('input[name="thirdPartyCode"]')?.value || "";
    const thirdPartyVehicleRegistration = document.querySelector('input[name="thirdPartyVehicleRegistration"]')?.value || "";
    const thirdPartyVehicleBrand = document.querySelector('input[name="thirdPartyVehicleBrand"]')?.value || "";
    const thirdPartyVehicleModel = document.querySelector('input[name="thirdPartyVehicleModel"]')?.value || "";
    const thirdPartyVehicleFirstCirculation = document.querySelector('input[name="thirdPartyVehicleFirstCirculation"]')?.value || "";
    const thirdPartyVehiclePower = document.querySelector('input[name="thirdPartyVehiclePower"]')?.value || "";
    const thirdPartyVehicleChassis = document.querySelector('input[name="thirdPartyVehicleChassis"]')?.value || "";
    const thirdPartyVehicleSeats = document.querySelector('input[name="thirdPartyVehicleSeats"]')?.value || "";
    
    // Third Party Address
    const thirdPartyAddress = document.querySelector('input[name="thirdPartyAddress"]')?.value || "";
    const thirdPartyCity = document.querySelector('input[name="thirdPartyCity"]')?.value || "";

    // ===== EXPERTISE SECTION =====
    const missionType = document.querySelector('select[name="missionType"]')?.value || "";
    const expertUid = document.querySelector('select[name="expert"]')?.value || "";
    const expertiseDate = document.querySelector('input[name="expertiseDate"]')?.value || "";
    const expertiseStatus = document.querySelector('select[name="expertiseStatus"]')?.value || "OPEN";
    const expertiseLocation = document.querySelector('input[name="expertiseLocation"]')?.value || "";
    const currentCarValue = document.querySelector('input[name="currentCarValue"]')?.value || "";
    const initialCarValue = document.querySelector('input[name="initialCarValue"]')?.value || "";

    // ===== VALIDATION =====
    // Same rule as the gateway and the MAE ETL
    if (!/^[A-Za-z0-9]{4,20}$/.test(policyNumber.trim())) {
      toast.error("Le numéro de police doit contenir de 4 à 20 lettres ou chiffres (sans point, espace ni barre)");
      return;
    }
    if (thirdPartyPolicyNumber && !/^[A-Za-z0-9]{4,20}$/.test(thirdPartyPolicyNumber.trim())) {
      toast.error("Le numéro de police du tiers doit contenir de 4 à 20 lettres ou chiffres");
      return;
    }
    if (!claimNumber) {
      toast.error("Le numéro de sinistre est requis");
      return;
    }
    if (!occurrenceDate) {
      toast.error("La date de survenance est requise");
      return;
    }
    if (!declarationDate) {
      toast.error("La date de déclaration est requise");
      return;
    }
    if (!reportingAgency) {
      toast.error("L'agence de déclaration est requise");
      return;
    }
    
    // Validate dates if policy dates are provided (for policy creation)
    if (policyEffectDate && policyExpirationDate) {
      const effectDate = new Date(policyEffectDate);
      const expirationDate = new Date(policyExpirationDate);
      if (expirationDate <= effectDate) {
        toast.error("La date d'expiration doit être postérieure à la date d'effet");
        return;
      }
    }
    
    // Warning if policy creation fields are partially filled
    const hasPolicyCreationFields = policyType || policyHolderCode || policyEffectDate;
    if (hasPolicyCreationFields && !policyEffectDate) {
      toast.warning("Pour créer une nouvelle police, veuillez remplir au minimum: Date d'effet");
    }
    // ms-policy refuses a policy without usage: block instead of a silent failure
    // (only when the policy will be created, i.e. not found by the search)
    const foundPolicyNumber = document.querySelector('input[name="foundPolicyNumber"]')?.value || "";
    if (policyEffectDate && !policyUsage && foundPolicyNumber !== policyNumber.trim()) {
      toast.error("Pour créer la police, veuillez choisir son usage");
      return;
    }

    // Validate claim amount is a number
    const claimAmountNum = parseFloat(claimAmount) || 0;
    const recourseAmountNum = parseFloat(recourseAmount) || 0;

    // Validate expertise: if missionType is provided, expertUid is required
    if (missionType && !expertUid) {
      toast.error("L'expert est requis lorsqu'un type de mission est sélectionné");
      return;
    }

    // Validate dates
    const occDate = new Date(occurrenceDate);
    const declDate = new Date(declarationDate);
    if (declDate < occDate) {
      toast.error("La date de déclaration doit être postérieure ou égale à la date de survenance");
      return;
    }

    // Map French mission type labels to English enum values
    const missionTypeMap = {
      "Première Expertise": "FIRST_INSPECTION",
      "Deuxième Expertise": "SECOND_INSPECTION",
      "Contre-Expertise": "COUNTER_INSPECTION",
      "Arbitrage": "ARBITRATION",
      "Arbitrage Client MAE": "MAE_CLIENT_ARBITRATION",
      "Rapport De Carrence": "CARRENCE_REPORT",
      "Expertise Judiciare": "JUDICIAL_INSPECTION"
    };

    // ===== BUILD REQUEST PAYLOAD =====
    const requestPayload = {
      // Manual creation: an existing claimNumber is refused (409) instead of
      // being enriched like an ETL re-run
      options: { failIfExists: true },
      contract: {
        policyNumber: policyNumber.trim(),
        role: "InsuredPolicy",
        vehicleRole: "INSURED_CAR",
      },
      claim: {
        claimNumber: claimNumber,
        occurrenceDate: new Date(occurrenceDate).toISOString(),
        reportingDate: new Date(declarationDate).toISOString(),
        reportingAgency: reportingAgency,
        claimAmount: claimAmountNum,
        reportingType: reportingType,
        damageType: damageType,
        responsability: responsibility,
        status: claimStatus,
        managementType: managementType,
        // flagFraud is always false (handled in backend)
        recourseAmount: recourseAmountNum,
        additionalData: {}
      },
    };

    // Add optional contract fields
    if (policyType) requestPayload.contract.policyType = policyType;
    if (policyUsage) requestPayload.contract.policyUsage = policyUsage;
    
    // Policy Holder - IMPORTANT: Use code or identity number as policyHolder for person lookup/creation
    if (policyHolderCode || policyHolderIdentityNumber) {
      requestPayload.contract.policyHolder = policyHolderCode || policyHolderIdentityNumber;
    }
    if (policyHolderCode) requestPayload.contract.policyHolderCode = policyHolderCode;
    if (policyHolderIdentityNumber) requestPayload.contract.policyHolderIdentityNumber = policyHolderIdentityNumber;
    if (policyHolderFirstName) requestPayload.contract.policyHolderFirstName = policyHolderFirstName;
    if (policyHolderLastName) requestPayload.contract.policyHolderLastName = policyHolderLastName;
    if (policyHolderBirthDate) requestPayload.contract.policyHolderBirthDate = new Date(policyHolderBirthDate).toISOString();
    if (policyHolderRole) requestPayload.contract.policyHolderRole = policyHolderRole;
    
    // Policy Dates
    if (policyEffectDate) requestPayload.contract.subscriptionDate = new Date(policyEffectDate).toISOString();
    if (policyExpirationDate) requestPayload.contract.expirationDate = new Date(policyExpirationDate).toISOString();
    
    // Reference Entities
    if (agencyLabel) requestPayload.contract.agencyLabel = agencyLabel;

    // Add vehicles array if vehicle information is provided
    if (vehicleRegistrationNumber || vehicleBrand || vehicleModel) {
      const vehicle = {
        type: "VEHICULE",
      };
      
      if (vehicleRegistrationNumber) vehicle.registrationNumber = vehicleRegistrationNumber;
      if (vehicleBrand) vehicle.brand = vehicleBrand;
      if (vehicleModel) vehicle.model = vehicleModel;
      if (vehicleFirstCirculationDate) vehicle.firstCirculationDate = vehicleFirstCirculationDate;
      
      // Only add numeric values if they are valid numbers
      if (vehiclePower && !isNaN(parseInt(vehiclePower))) {
        vehicle.power = parseInt(vehiclePower);
      }
      if (vehicleSeatsNumber && !isNaN(parseInt(vehicleSeatsNumber))) {
        vehicle.seatsNumber = parseInt(vehicleSeatsNumber);
      }
      
      if (vehicleEngineNumber) vehicle.engineNumber = vehicleEngineNumber;
      if (vehicleChassisNumber) vehicle.chassisNumber = vehicleChassisNumber;
      
      requestPayload.contract.vehicles = [vehicle];
    }

    // Add optional claim fields (main claim object - NOT in additionalData)
    if (registrationNumber) requestPayload.claim.registrationNumber = registrationNumber;
    if (driver) requestPayload.claim.driver = driver;
    if (claimLocation) requestPayload.claim.location = claimLocation;
    if (carLocation) requestPayload.claim.carLocation = carLocation;
    if (vehicleState) requestPayload.claim.vehicleState = vehicleState;
    
    // DAAQ is built by the gateway from the agency code, like the ETL:
    // /claim/classique/{region}/{agency}/{expert}

    // Coverage codes, resolved by the gateway against the ms-claim catalogue
    if (selectedCoverages && selectedCoverages.length > 0) {
      requestPayload.claim.coverageCodes = selectedCoverages;
    }
    
    // Add ONLY these specific fields to additionalData (as per API spec)
    // Initialize additionalData object first
    requestPayload.claim.additionalData = {};
    
    if (typeOfClaim) requestPayload.claim.additionalData.typeOfClaim = typeOfClaim;
    if (reportingNumber) requestPayload.claim.additionalData.reportingNumber = reportingNumber;
    // Note: idMissionPi and idMissionType are filled dynamically during claim lifecycle
    
    // Remove additionalData if empty
    if (requestPayload.claim.additionalData && Object.keys(requestPayload.claim.additionalData).length === 0) {
      delete requestPayload.claim.additionalData;
    }

    // Add third party if provided
    if (thirdPartyType === "organization" && thirdPartyOrganizationName) {
      requestPayload.thirdParty = {
        organizationName: thirdPartyOrganizationName,
        role: thirdPartyRole,
      };
      if (thirdPartyActivity) requestPayload.thirdParty.activity = thirdPartyActivity;
      if (thirdPartyTaxId) requestPayload.thirdParty.taxId = thirdPartyTaxId;
      
      // Add policy number (for linking Good to policy)
      if (thirdPartyPolicyNumber) {
        requestPayload.thirdParty.policyNumber = thirdPartyPolicyNumber;
      }
      
      // Add policy fields for third party policy creation
      if (thirdPartyPolicyType) requestPayload.thirdParty.policyType = thirdPartyPolicyType;
      if (thirdPartySubscriptionDate) requestPayload.thirdParty.subscriptionDate = new Date(thirdPartySubscriptionDate).toISOString();
      if (thirdPartyExpirationDate) requestPayload.thirdParty.expirationDate = new Date(thirdPartyExpirationDate).toISOString();
      // cancelationDate is automatically set to expirationDate in backend
      if (thirdPartyCode) requestPayload.thirdParty.code = thirdPartyCode;
      
      // Add address to additionalData only if provided
      if (thirdPartyAddress || thirdPartyCity) {
        requestPayload.thirdParty.additionalData = {};
        if (thirdPartyAddress) requestPayload.thirdParty.additionalData.address = thirdPartyAddress;
        if (thirdPartyCity) requestPayload.thirdParty.additionalData.city = thirdPartyCity;
      }
      
      // Build third party vehicle object for Good creation (with GoodCaracteristiques)
      if (thirdPartyVehicleRegistration) {
        const thirdPartyVehicle = {
          type: "VEHICULE",
          registrationNumber: thirdPartyVehicleRegistration,
        };
        
        // Link to policy if provided
        if (thirdPartyPolicyNumber) thirdPartyVehicle.policyNumber = thirdPartyPolicyNumber;
        
        // Add vehicle characteristics
        if (thirdPartyVehicleBrand) thirdPartyVehicle.brand = thirdPartyVehicleBrand;
        if (thirdPartyVehicleModel) thirdPartyVehicle.model = thirdPartyVehicleModel;
        if (thirdPartyVehicleFirstCirculation) thirdPartyVehicle.firstCirculationDate = thirdPartyVehicleFirstCirculation;
        
        // Numeric characteristics (only if valid)
        const thirdPartyPowerNum = parseInt(thirdPartyVehiclePower);
        if (thirdPartyVehiclePower && !isNaN(thirdPartyPowerNum) && thirdPartyPowerNum > 0) {
          thirdPartyVehicle.power = thirdPartyPowerNum;
        }
        
        const thirdPartySeatsNum = parseInt(thirdPartyVehicleSeats);
        if (thirdPartyVehicleSeats && !isNaN(thirdPartySeatsNum) && thirdPartySeatsNum > 0) {
          thirdPartyVehicle.seatsNumber = thirdPartySeatsNum;
        }
        
        if (thirdPartyVehicleChassis) thirdPartyVehicle.chassisNumber = thirdPartyVehicleChassis;
        
        // Add vehicle object to thirdParty for Good creation
        requestPayload.thirdParty.vehicle = thirdPartyVehicle;
      }
    } else if (thirdPartyType === "person" && (thirdPartyFirstName || thirdPartyLastName)) {
      requestPayload.thirdParty = {
        firstName: thirdPartyFirstName,
        lastName: thirdPartyLastName,
        role: thirdPartyRole,
      };
      if (thirdPartyIdentityNumber) requestPayload.thirdParty.identityNumber = thirdPartyIdentityNumber;
      if (thirdPartyBirthDate) requestPayload.thirdParty.birthDate = new Date(thirdPartyBirthDate).toISOString();
      
      // Add policy number (for linking Good to policy)
      if (thirdPartyPolicyNumber) {
        requestPayload.thirdParty.policyNumber = thirdPartyPolicyNumber;
      }
      
      // Add policy fields for third party policy creation
      if (thirdPartyPolicyType) requestPayload.thirdParty.policyType = thirdPartyPolicyType;
      if (thirdPartySubscriptionDate) requestPayload.thirdParty.subscriptionDate = new Date(thirdPartySubscriptionDate).toISOString();
      if (thirdPartyExpirationDate) requestPayload.thirdParty.expirationDate = new Date(thirdPartyExpirationDate).toISOString();
      // cancelationDate is automatically set to expirationDate in backend
      if (thirdPartyCode) requestPayload.thirdParty.code = thirdPartyCode;
      
      // Add address to additionalData only if provided
      if (thirdPartyAddress || thirdPartyCity) {
        requestPayload.thirdParty.additionalData = {};
        if (thirdPartyAddress) requestPayload.thirdParty.additionalData.address = thirdPartyAddress;
        if (thirdPartyCity) requestPayload.thirdParty.additionalData.city = thirdPartyCity;
      }
      
      // Build third party vehicle object for Good creation (with GoodCaracteristiques)
      if (thirdPartyVehicleRegistration) {
        const thirdPartyVehicle = {
          type: "VEHICULE",
          registrationNumber: thirdPartyVehicleRegistration,
          policyNumber: thirdPartyPolicyNumber, // Link to third party policy
        };
        
        // Add vehicle characteristics
        if (thirdPartyVehicleBrand) thirdPartyVehicle.brand = thirdPartyVehicleBrand;
        if (thirdPartyVehicleModel) thirdPartyVehicle.model = thirdPartyVehicleModel;
        if (thirdPartyVehicleFirstCirculation) thirdPartyVehicle.firstCirculationDate = thirdPartyVehicleFirstCirculation;
        
        // Numeric characteristics (only if valid)
        const thirdPartyPowerNum = parseInt(thirdPartyVehiclePower);
        if (thirdPartyVehiclePower && !isNaN(thirdPartyPowerNum) && thirdPartyPowerNum > 0) {
          thirdPartyVehicle.power = thirdPartyPowerNum;
        }
        
        const thirdPartySeatsNum = parseInt(thirdPartyVehicleSeats);
        if (thirdPartyVehicleSeats && !isNaN(thirdPartySeatsNum) && thirdPartySeatsNum > 0) {
          thirdPartyVehicle.seatsNumber = thirdPartySeatsNum;
        }
        
        if (thirdPartyVehicleChassis) thirdPartyVehicle.chassisNumber = thirdPartyVehicleChassis;
        
        // Add vehicle object to thirdParty for Good creation
        requestPayload.thirdParty.vehicle = thirdPartyVehicle;
      }
      
      // Remove additionalData if empty
      if (requestPayload.thirdParty.additionalData && Object.keys(requestPayload.thirdParty.additionalData).length === 0) {
        delete requestPayload.thirdParty.additionalData;
      }
    }

    // The gateway processes the adverse policy and car from these two arrays
    // (same shape as the ETL payload); thirdParty.policyNumber lets it create
    // the adverse policy with the third party as holder.
    if (requestPayload.thirdParty) {
      if (thirdPartyPolicyNumber) {
        requestPayload.thirdParty.policyNumber = thirdPartyPolicyNumber.trim();
        requestPayload.adversePolicies = [thirdPartyPolicyNumber.trim()];
      }
      if (requestPayload.thirdParty.vehicle) {
        requestPayload.adverseCars = [requestPayload.thirdParty.vehicle];
        delete requestPayload.thirdParty.vehicle;
      }
    }

    // Add expertise/inspection mission if provided
    if (missionType && expertUid) {
      const mappedMissionType = missionTypeMap[missionType] || missionType;
      
      requestPayload.expertise = {
        missionType: mappedMissionType,
        expertUid: expertUid,
        status: expertiseStatus,
      };
      
      if (expertiseDate) requestPayload.expertise.missionDate = new Date(expertiseDate).toISOString();
      if (expertiseLocation) requestPayload.expertise.location = expertiseLocation;
      
      // Car values: Always send valid numbers that pass isNumber() validation
      // isNumber requires: !isNaN, isFinite, >= 0, toString() match
      const currentCarValueNum = parseFloat(currentCarValue);
      requestPayload.expertise.currentCarValue = (currentCarValue && !isNaN(currentCarValueNum) && currentCarValueNum >= 0) 
        ? currentCarValueNum 
        : 0;
      
      const initialCarValueNum = parseFloat(initialCarValue);
      requestPayload.expertise.initialCarValue = (initialCarValue && !isNaN(initialCarValueNum) && initialCarValueNum >= 0) 
        ? initialCarValueNum 
        : 0;
    }

    console.log("Submitting claim creation request:", requestPayload);

    const response = await dispatch(Actions.createCompleteClaim(requestPayload));

      if (response.success) {
        toast.success("Sinistre créé avec succès!");
        
        if (response.claimNumber) {
          toast.info(`N° Sinistre: ${response.claimNumber}`);
        }

        // Show policy creation info
        if (response.createdResources?.policy?.exists === false) {
          toast.info(`Police créée: ${response.createdResources.policy.policyNumber}`);
        }

        // Show policy holder involved party info
        if (response.createdResources?.policyHolderInvolvedParty?.linked) {
          const role = response.createdResources.policyHolderInvolvedParty.role || "InsuredDriver";
          toast.info(`Souscripteur lié en tant que: ${role}`);
        }

        // Show vehicle creation info
        if (response.createdResources?.goods?.length > 0) {
          toast.info(`${response.createdResources.goods.length} véhicule(s) créé(s)`);
        }

        // Show third party info
        if (response.createdResources?.thirdParty) {
          const thirdPartyExists = response.createdResources.thirdParty.exists ? "existant" : "créé";
          toast.info(`Tiers ${thirdPartyExists}: ${response.createdResources.thirdParty.uid}`);
        }

        // Show third party involved party link
        if (response.createdResources?.thirdPartyInvolvedParty?.linked) {
          const role = response.createdResources.thirdPartyInvolvedParty.role || "AdverseDriver";
          toast.info(`Tiers lié en tant que: ${role}`);
        }

        // Show third party Good creation
        if (response.createdResources?.thirdPartyGood?.created) {
          toast.info(`Véhicule tiers créé: ${response.createdResources.thirdPartyGood.uid}`);
        }

        // Show inspection mission info if created
        if (response.createdResources?.inspectionMission?.missionCode) {
          toast.info(`Mission créée: ${response.createdResources.inspectionMission.missionCode}`);
        }

        // Show warnings for partial errors
        if (response.errors && response.errors.length > 0) {
          response.errors.forEach(error => {
            toast.warning(`${error.step}: ${error.message}`);
          });
        }

        setOpenAddDialog(false);
        onCreated?.();
      } else {
        throw new Error(response.error || "Erreur lors de la création du sinistre");
      }

  } catch (error) {
    console.error("Error creating claim:", error);
    const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message;
    toast.error(`Erreur: ${errorMessage}`);
    
    if (error.response?.data?.errors && Array.isArray(error.response.data.errors)) {
      error.response.data.errors.forEach(err => {
        toast.error(`${err.step}: ${err.message}`);
      });
    }
  } finally {
    setIsSubmitting(false);
  }
};

